<template>
  <BaseInputText v-bind="$attrs"
                 v-on="$listeners"
                 v-model="input"
                 :inputContainerStyle="inputContainerStyle"
                 :inputStyle="inputStyle"
                 @keydown.enter="addTag"
                 @keydown.8="popTag">
    <template v-slot:fixed-plugin-left>
      <slot name="fixed-plugin-left" />
    </template>
    <template v-slot:plugin-left>
      <div :style="{ display: 'flex', alignItems: 'center', height: '100%' }">
        <BaseTags :tags="tags"
                  :tagStyle="tagStyle"
                  @remove-tag="tagIndex => $emit('remove-tag', tagIndex)"/>
      </div>
    </template>
    <template v-slot:plugin-right>
      <slot name="plugin-right" />
    </template>
    <template v-slot:clear-button>
      <slot name="clear-button" />
    </template>
    <template v-slot:fixed-plugin-right>
      <slot name="fixed-plugin-right" />
    </template>
    <template v-slot:popover>
      <slot name="popover" />
    </template>
  </BaseInputText>
</template>

<script>
  import BaseInputText from '@base/base-input-text'
  import BaseTags from '@base/base-tags'

  export default {
    name: 'BaseTagInputText',
    inheritAttrs: false,
    model: {
      prop: 'vmodelValue',
      event: 'input',
    },
    components: {
      BaseInputText,
      BaseTags,
    },
    props: {
      vmodelValue: { type: String },
      tags: { type: Array, required: true },
      inputContainerStyle: { type: Object, required: false, default: () => {}},
      inputStyle: { type: Object, required: false, default: () => {}},
      tagStyle: { type: Object, required: false, default: () => {}},
    },
    data: function () {
      return {
        input: '',
      };
    },
    created: function () {
      this.input = this.vmodelValue;
    },
    methods: {
      addTag: function () {
        if (this.disableCreateTagByEnter || this.input.trim().length === 0) {
          return;
        }

        this.$emit('add-tag', this.input.trim());
      },
      popTag: function (event) {
        if (this.input.length > 0) {
          return;
        }
        event.preventDefault();
        this.$emit('pop-tag');
      },
      duplicateValidator: function (tag, tags) {
        const trimmedTag = tag.trim();
        const duplicates = tags.filter((tag) => tag === trimmedTag);
        const status = duplicates.length > 0 ? 'error' : 'success';
        const message = status === 'success' ? '' : 'Duplicate tag exists.';
        return { status: status, message: message };
      },
    },
    watch: {
      vmodelValue: function (newVal, oldVal) {
        this.input = newVal;
      },
    },
  };
</script>
